import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MenuButtonTitleVariantConstantType,
    MenuButtonGuideConstantType,
    MenuDynamicStyle,
    MenuButtonLevel
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    webStyle
} from "../../utils";

export const MENU_BUTTON_TITLE_VARIANTS: Record<MenuButtonLevel, keyof NCoreUIKit.Typography> = {
    main: "labelMediumSize",
    sub: "bodyMediumSize"
};

export const getMenuButtonGuideStyle = ({
    borders,
    colors,
    spaces
}: MenuButtonGuideConstantType): ViewStyle => {
    return {
        marginStart: spaces.spacingSm + spaces.spacingXs,
        borderStartColor: colors.content.border.subtle,
        borderStartWidth: borders.separator
    };
};

export const getMenuButtonTitleVariant = ({
    depth
}: MenuButtonTitleVariantConstantType): keyof NCoreUIKit.Typography => {
    return MENU_BUTTON_TITLE_VARIANTS[depth ? "sub" : "main"];
};

const stylesheet = StyleSheet.create({
    contentContainer: {
        justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "stretch"
    },
    container: {
        flexDirection: "column",
        display: "flex",
        flex: 1
    },
    content: {
        flex: 1,
        ...webStyle({
            overflowX: "hidden"
        })
    },
    footer: {
        flexDirection: "column"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    safeAreaView: {
        flex: 1
    },
    separator: {
    }
});

export const useStyles = ({
    customBackgroundColorKey,
    customBackgroundColor,
    glassEffect,
    colors,
    spaces
}: MenuDynamicStyle) => {
    const styles = {
        container: {
            ...webStyle({
                WebkitBackdropFilter: `blur(${glassEffect}px)`,
                backdropFilter: `blur(${glassEffect}px)`
            })
        } as Mutable<ViewStyle>,
        headerContainer: {
            padding: spaces.spacingMd,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        footer: {
            padding: spaces.spacingMd,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        contentContainer: {
            padding: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(customBackgroundColor) {
        styles.container.backgroundColor = customBackgroundColor;
    }

    if(customBackgroundColorKey) {
        styles.container.backgroundColor = colors.project[customBackgroundColorKey];
    }

    return styles;
};

export default stylesheet;
